@if (!mobileDetailedView()) {
  @if (isLoading()) {
  <div class="px-4">
    <!-- Header Skeleton -->
    <div class="flex items-center justify-between mb-6 pt-6 animate-pulse">
      <div>
        <div class="h-7 w-48 bg-gray-200 rounded-lg mb-2"></div>
        <div class="h-3 w-32 bg-gray-100 rounded-lg"></div>
      </div>
      <div class="h-10 w-10 bg-gray-100 rounded-full"></div>
    </div>

    <!-- AI Headlines Skeleton -->
    <div class="mb-6 -mx-1 h-20 bg-gray-100 rounded-2xl animate-pulse"></div>

    <!-- Active Businesses Skeleton -->
    <div class="bg-white border-[1.0839px] border-[#F5F5F5] rounded-2xl w-full h-[230px] mb-6 relative overflow-hidden animate-pulse">
      <div class="absolute left-4 top-[16.99px] h-5 w-32 bg-gray-100 rounded-lg"></div>
      <div class="absolute right-12 top-[16.99px] h-5 w-20 bg-gray-50 rounded-lg"></div>
      <div class="absolute left-4 top-[52.99px] h-10 w-24 bg-gray-200 rounded-lg"></div>
      <div class="absolute left-[144px] right-4 top-[60px] bottom-[30px] flex items-end justify-end gap-[13px]">
        <div class="w-[14px] h-[40%] bg-gray-100 rounded-full"></div>
        <div class="w-[14px] h-[60%] bg-gray-100 rounded-full"></div>
        <div class="w-[14px] h-[30%] bg-gray-100 rounded-full"></div>
        <div class="w-[14px] h-[70%] bg-gray-100 rounded-full"></div>
        <div class="w-[14px] h-[50%] bg-gray-100 rounded-full"></div>
        <div class="w-[14px] h-[80%] bg-gray-100 rounded-full"></div>
        <div class="w-[14px] h-[45%] bg-gray-100 rounded-full"></div>
      </div>
      <div class="absolute left-4 top-[126px] w-[52px] h-[30px] flex flex-col gap-1">
        <div class="h-3 w-full bg-gray-100 rounded"></div>
        <div class="h-3 w-2/3 bg-gray-50 rounded"></div>
      </div>
      <div class="absolute left-4 right-4 top-[169px] h-[5px] bg-gray-100 rounded-full"></div>
      <div class="absolute left-4 top-[178px] w-16 h-6 bg-gray-200 rounded-lg"></div>
    </div>

    <!-- Top 10 Businesses Skeleton -->
    <div class="bg-white border-[1.0839px] border-[#F5F5F5] rounded-2xl w-full h-[230px] mb-6 relative animate-pulse overflow-hidden">
      <div class="absolute left-4 top-[16.99px] h-5 w-48 bg-gray-100 rounded-lg"></div>
      <div class="absolute inset-x-4 bottom-[15px] top-[65px] flex items-end justify-center gap-2">
        <div class="w-[33%] h-[60%] bg-gray-100 rounded-t-lg"></div>
        <div class="w-[33%] h-[80%] bg-gray-200 rounded-t-lg"></div>
        <div class="w-[33%] h-[50%] bg-gray-100 rounded-t-lg"></div>
      </div>
    </div>

    <!-- Top Categories Skeleton -->
    <div class="bg-white border-[1.0839px] border-[#F5F5F5] rounded-2xl w-full min-h-[230px] mb-6 p-4 flex flex-col gap-6 animate-pulse">
      <div class="flex justify-between">
        <div class="h-5 w-40 bg-gray-200 rounded-lg"></div>
        <div class="h-5 w-16 bg-gray-100 rounded-lg"></div>
      </div>
      <div class="flex flex-col gap-6">
        @for (i of [1,2,3]; track i) {
          <div class="flex flex-col gap-2">
            <div class="flex justify-between">
              <div class="h-4 w-24 bg-gray-100 rounded"></div>
              <div class="h-4 w-12 bg-gray-100 rounded"></div>
            </div>
            <div class="w-full h-3 bg-gray-50 rounded-full"></div>
          </div>
        }
      </div>
    </div>

    <!-- Summary Stats Grid Skeleton -->
    <div class="grid grid-cols-2 gap-4 mb-6">
      @for (i of [1,2]; track i) {
        <div class="bg-white border-[1.0839px] border-[#F5F5F5] rounded-2xl p-4 flex flex-col justify-between h-[180px] animate-pulse">
          <div class="w-10 h-10 bg-gray-100 rounded-xl"></div>
          <div class="mt-4">
            <div class="h-3 w-full bg-gray-100 rounded mb-2"></div>
            <div class="h-8 w-16 bg-gray-200 rounded-lg mb-2"></div>
            <div class="h-3 w-20 bg-gray-100 rounded"></div>
          </div>
        </div>
      }
    </div>

    <!-- Overall Contract Grid Skeleton -->
    <div class="grid grid-cols-2 gap-4">
       @for (i of [1,2,3,4]; track i) {
        <div class="bg-white border-[1.0839px] border-[#F5F5F5] rounded-2xl p-4 flex flex-col justify-between h-[180px] animate-pulse">
          <div class="w-10 h-10 bg-gray-100 rounded-xl"></div>
          <div class="mt-4">
            <div class="h-3 w-full bg-gray-100 rounded mb-2"></div>
            <div class="h-8 w-16 bg-gray-200 rounded-lg"></div>
          </div>
        </div>
      }
    </div>
  </div>
  } @else {
  <div class="px-4 dark:bg-surface-1">
  <!-- Page Title & Date Filter -->
  <div class="flex items-center justify-between mb-6 pt-6">
    <div>
      <h1 class="text-xl font-bold text-[#141437] dark:text-white">Monthly Report 1</h1>
      <p class="text-[10px] font-bold text-purple-600 uppercase tracking-widest mt-1 dark:text-ink-soft">
        {{ startDate() | date:'MMM dd, yyyy' }} - {{ endDate() | date:'MMM dd, yyyy' }}
      </p>  
    </div>
    <button (click)="openFilterSheet()"
      class="h-10 w-10 flex items-center justify-center bg-white rounded-full border border-gray-200 text-blue-500 transition-all active:scale-95 shadow-sm dark:bg-surface-1 dark:border-line">
      <app-icon-v2 name="funnel" [size]="20"></app-icon-v2>
    </button>
  </div>

  <!-- AI Headlines Widget -->
  <div class="mb-6 -mx-1">
    <ai-headlines></ai-headlines>
  </div>

  <!-- Active Businesses Card -->
  <div
    class="bg-white dark:bg-surface-0 dark:border-surface-0 border-[1.0839px] border-[#F5F5F5] rounded-2xl shadow-[0px_12px_16px_-4px_rgba(16,24,40,0.08),0px_4px_6px_-2px_rgba(16,24,40,0.03)] w-full h-[230px] mb-6 relative overflow-hidden">
    
    <!-- Header Container -->
    <div class="absolute left-4 right-4 top-[16.99px] h-7 flex items-center justify-between z-20">
      <h3 class="text-[14px] font-bold text-[#38385B] leading-5 dark:text-white">Active Businesses</h3>
      <div class="flex-1 flex justify-end pr-8">
        <button (click)="openMobileDetail('activeBusinesses')" class="text-[12px] font-medium text-[#0C66E8] leading-5 text-right whitespace-nowrap">
          View All Business
        </button>
      </div>
    </div>

    <!-- Grip/Ellipsis Icon -->
    <div class="absolute right-2 top-5 w-4 h-[22px] flex items-center justify-center z-20">
      <app-icon-v2 name="GripVertical" [size]="16" customClass="text-[#7D7D93]"></app-icon-v2>
    </div>

    <!-- Total Value Container -->
    <div class="absolute left-4 right-4 top-[52.99px] h-[50px] z-10">
      <span class="text-[32px] font-bold text-[#141437] leading-[38px] tracking-[-0.01em] font-['Lato'] dark:text-ink-muted">
        {{ activeBusiness()?.statsData?.total || 0 }}
      </span>
    </div>

    <!-- Chart Frame -->
    <div class="absolute left-[144px] right-4 top-[60px] bottom-[30px] flex items-end justify-end gap-[13px] z-0 dark:text-ink-muted">
      @for (item of (activeBusiness()?.chartData?.slice(-7) || []); track $index) {
      <div class="w-[14px] bg-[#F4E5FF] rounded-full transition-all duration-700 ease-out"
        [style.height.%]="maxActiveBusinessValue() > 0 ? (item.value / maxActiveBusinessValue()) * 100 : 0">
      </div>
      }
    </div>

    <!-- Average Business Label -->
    <div class="absolute left-4 top-[126px] w-[52px] h-[30px] flex flex-col justify-center z-10">
      <span class="text-[12px] font-medium text-[#38385B] leading-[15px] dark:text-ink-muted">Average Business</span>
    </div>

    <!-- Thick Purple Line -->
    <div class="absolute left-4 right-4 top-[169px] h-[5px] bg-[#AD46FF] rounded-full z-10"></div>

    <!-- Average Value -->
    <div class="absolute left-4 top-[178px] w-[43px] h-[23px] flex items-center z-10">
      <span class="text-[24px] font-medium text-[#141437] leading-[23px] dark:text-ink-muted">
        {{ activeBusiness()?.statsData?.average_last_6 || activeBusiness()?.statsData?.average || 0 }}
      </span>
    </div>
  </div>

  <!-- Top 10 Businesses by Contracts Card -->
  <div
    class="bg-white border-[1.0839px] border-[#F5F5F5] rounded-2xl shadow-[0px_12px_16px_-4px_rgba(16,24,40,0.08),0px_4px_6px_-2px_rgba(16,24,40,0.03)] w-full h-[230px] mb-6 relative dark:bg-surface-0 dark:border-surface-0">
    
    <!-- Header Container -->
    <div class="absolute left-4 right-4 top-[16.99px] h-7 flex items-center justify-between z-20">
      <h3 class="text-[14px] font-bold text-[#38385B] leading-5 dark:text-white">Top 10 Businesses by Contracts</h3>
      <div class="flex-1 flex justify-end pr-8">
        <button (click)="openMobileDetail('topBusinesses')" class="text-[12px] font-medium text-[#0C66E8] leading-5 text-right whitespace-nowrap">
          View All
        </button>
      </div>
    </div>

    <!-- Grip/Ellipsis Icon -->
    <div class="absolute right-2 top-5 w-4 h-[22px] flex items-center justify-center z-20">
      <app-icon-v2 name="GripVertical" [size]="16" customClass="text-[#7D7D93]"></app-icon-v2>
    </div>

    <!-- Podium Chart Container -->
    <div class="absolute inset-x-4 bottom-[15px] top-[65px] flex items-end justify-center z-0">
      @for (item of podiumConfig(); track item.rank) {
        <div class="relative w-[33%] {{ item.barColor }} {{ item.z }} flex flex-col items-center justify-between {{ item.pb }} {{ item.pt }} px-1"
             [style.height]="item.barHeight">
          <!-- Rank Circle -->
          <div class="absolute {{ item.circleTop }} left-1/2 -translate-x-1/2 {{ item.circleSize }} bg-white rounded-full p-1 shadow-sm">
            <div class="w-full h-full bg-gradient-to-br {{ item.gradient }} dark:text-surface-1 rounded-full flex items-center justify-center text-white  font-bold {{ item.circleText }}">
              {{ item.rank }}
            </div>
          </div>
          <!-- Business Name -->
          <span class="{{ item.textSize }} text-white dark:text-surface-1 font-bold text-center line-clamp-2 px-1 leading-tight">{{ item.business.label }}</span>
          <!-- Value -->
          <span class="{{ item.valueSize }} text-[#141437] dark:text-surface-1 font-bold">{{ item.business.value }}</span>
        </div>
      }
    </div>
  </div>

  <!-- Top Categories by Contracts Card -->
  <div
    class="bg-white dark:bg-surface-0 dark:border-surface-0 border-[1.0839px] border-[#F5F5F5] rounded-2xl shadow-[0px_12px_16px_-4px_rgba(16,24,40,0.08),0px_4px_6px_-2px_rgba(16,24,40,0.03)] w-full min-h-[230px] mb-6 p-4 flex flex-col justify-between">
    
    <!-- Header Container -->
    <div class="flex items-center justify-between mb-4">
      <h3 class="text-[14px] dark:text-white font-bold text-[#38385B] leading-5">Top Categories by Contracts</h3>
      <div class="flex items-center gap-4">
        <button (click)="openMobileDetail('topCategories')" class="text-[12px] font-medium text-[#0C66E8] leading-5 text-right whitespace-nowrap">
          View All
        </button>
        <div class="w-4 h-[22px] flex items-center justify-center">
          <app-icon-v2 name="GripVertical" [size]="16" customClass="text-[#7D7D93]"></app-icon-v2>
        </div>
      </div>
    </div>

    <!-- Categories List -->
    <div class="flex flex-col gap-6">
      @for (item of categoryPodiumConfig(); track item.label) {
        <div class="flex flex-col gap-2">
          <div class="flex justify-between items-center px-1">
            <span class="text-[14px] font-medium text-[#38385B] dark:text-ink-muted">{{ item.label }}</span>
            <span class="text-[16px] font-bold text-[#141437] dark:text-ink-muted">{{ item.value }}</span>
          </div>
          <!-- Progress Bar -->
          <div class="w-full h-3 rounded-full bg-gray-100 overflow-hidden">
            <div 
              class="h-full rounded-full bg-gradient-to-r {{ item.bar }} transition-all duration-700 ease-out relative"
              [style.width.%]="item.percentage">
              <!-- Diagonal stripes overlay -->
              <div class="absolute inset-0 opacity-20"
                [style.background-image]="'repeating-linear-gradient(-45deg, transparent, transparent 4px, rgba(255,255,255,1) 4px, rgba(255,255,255,1) 8px)'">
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Summary Stats Cards -->
  <div class="grid grid-cols-2 gap-4 mb-6">
    <!-- Enrolled Businesses Card -->
    <div class="bg-white dark:bg-surface-0 dark:border-surface-0 border-[1.0839px] border-[#F5F5F5] rounded-2xl shadow-[0px_12px_16px_-4px_rgba(16,24,40,0.08),0px_4px_6px_-2px_rgba(16,24,40,0.03)] p-4 flex flex-col justify-between h-[180px]">
      <div class="flex justify-between items-start">
        <div class="w-10 h-10 bg-[#EFF6FF] rounded-xl flex items-center justify-center dark:bg-[rgba(59,130,246,0.15)]">
          <app-icon-v2 name="User" [size]="20" customClass="text-[#0C66E8]"></app-icon-v2>
        </div>
        <div class="flex items-center gap-2">
          <button (click)="openMobileDetail('enrolledBusinesses')" class="text-[12px] font-medium text-[#0C66E8]">View All</button>
          <div class="w-4 h-[22px] flex items-center justify-center">
            <app-icon-v2 name="GripVertical" [size]="16" customClass="text-[#7D7D93]"></app-icon-v2>
          </div>
        </div>
      </div>
      
      <div class="mt-4">
        <h3 class="text-[10px] font-bold text-gray-500 uppercase tracking-[0.1em] block mb-1 leading-tight min-h-[2.5em] dark:text-ink-muted">Enrolled Businesses</h3>
        <div class="mt-1 flex flex-col">
          <span class="text-[28px] font-bold text-[#141437] dark:text-ink-muted leading-tight">{{ enrolledCurrent() }}</span>
          <div class="flex items-center gap-1 mt-1" [ngClass]="enrolledGrowth() >= 0 ? 'text-[#15B268]' : 'text-[#F05050]'">
            <app-icon-v2 [name]="enrolledGrowth() >= 0 ? 'trendingUp' : 'trendingDown'" [size]="12"></app-icon-v2>
            <span class="text-[10px] font-medium">{{ enrolledGrowth() }}% vs last month</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Contracts Created Card -->
    <div class="bg-white dark:bg-surface-0 dark:border-surface-0 border-[1.0839px] border-[#F5F5F5] rounded-2xl shadow-[0px_12px_16px_-4px_rgba(16,24,40,0.08),0px_4px_6px_-2px_rgba(16,24,40,0.03)] p-4 flex flex-col justify-between h-[180px]">
      <div class="flex justify-between items-start">
        <div class="w-10 h-10 bg-[#EFF6FF] dark:bg-[rgba(59,130,246,0.15)] rounded-xl flex items-center justify-center">
          <app-icon-v2 name="pencil" [size]="20" customClass="text-[#0C66E8]"></app-icon-v2>
        </div>
        <div class="flex items-center gap-2">
          <button (click)="openMobileDetail('contractsCreated')" class="text-[12px] font-medium text-[#0C66E8]">View All</button>
          <div class="w-4 h-[22px] flex items-center justify-center">
            <app-icon-v2 name="GripVertical" [size]="16" customClass="text-[#7D7D93]"></app-icon-v2>
          </div>
        </div>
      </div>
      
      <div class="mt-4">
        <h3 class="text-[10px] font-bold text-gray-500 uppercase tracking-[0.1em] block mb-1 leading-tight min-h-[2.5em] dark:text-ink-muted">Contracts Created</h3>
        <div class="mt-1 flex flex-col">
          <span class="text-[28px] font-bold text-[#141437] dark:text-ink-muted leading-tight">{{ contractsCurrent() }}</span>
          <div class="flex items-center gap-1 mt-1 " [ngClass]="contractsGrowth() >= 0 ? 'text-[#15B268]' : 'text-[#F05050]'">
            <app-icon-v2 [name]="contractsGrowth() >= 0 ? 'trendingUp' : 'trendingDown'" [size]="12"></app-icon-v2>
            <span class="text-[10px] font-medium">{{ contractsGrowth() }}% vs last month</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Stats Grid -->
  <div class="grid grid-cols-2 gap-4">
    <!-- Overall Contract Card -->
    <div class="bg-white dark:bg-surface-0 dark:border-surface-0 border-[1.0839px] border-[#F5F5F5] rounded-2xl shadow-[0px_12px_16px_-4px_rgba(16,24,40,0.08),0px_4px_6px_-2px_rgba(16,24,40,0.03)] p-4 flex flex-col justify-between h-[180px]">
      <div class="flex justify-between items-start">
        <div class="w-10 h-10 bg-[#FF6900] rounded-xl flex items-center justify-center shadow-lg shadow-orange-200/50 dark:shadow-orange-800/50">
          <app-icon-v2 name="FileText" [size]="20" customClass="text-white"></app-icon-v2>
        </div>
        <div class="flex items-center gap-2">
          <button (click)="openMobileDetail('overallContracts')" class="text-[12px] font-medium text-[#0C66E8]">View All</button>
          <div class="w-4 h-[22px] flex items-center justify-center">
            <app-icon-v2 name="GripVertical" [size]="16" customClass="text-[#7D7D93]"></app-icon-v2>
          </div>
        </div>
      </div>
      <div class="mt-4">
        <h3 class="text-[10px] font-bold text-gray-500 uppercase tracking-[0.1em] block mb-1 leading-tight min-h-[2.5em]  dark:text-ink-muted">Overall Contract</h3>
        <div class="mt-1 flex flex-col">
          <span class="text-[28px] font-bold text-[#141437] leading-tight dark:text-ink-muted">{{ contractsCurrent() }}</span>
          <div class="flex items-center gap-1 mt-1" [ngClass]="contractsGrowth() >= 0 ? 'text-[#15B268]' : 'text-[#F05050]'">
            <app-icon-v2 [name]="contractsGrowth() >= 0 ? 'trendingUp' : 'trendingDown'" [size]="12"></app-icon-v2>
            <span class="text-[10px] font-medium">{{ contractsGrowth() }}% vs last month</span>
          </div>
        </div>
      </div>
    </div>

    @for (stat of businessContractTypes(); track stat.label; let i = $index) {
    <div
      class="bg-white dark:bg-surface-0 dark:border-surface-0 border border-gray-100 rounded-3xl p-5 shadow-sm transition-all active:scale-[0.98]">
      <div [ngClass]="stat.bgClass"
        class="w-10 h-10 rounded-xl flex items-center justify-center mb-4 shadow-lg shadow-gray-200/50 dark:shadow-gray-800/50">
        <app-icon-v2 name="fileText" [size]="20" class="text-white"></app-icon-v2>
      </div>
      <span
        class="text-[10px] font-bold text-gray-500 uppercase tracking-[0.1em] block mb-1 leading-tight min-h-[2.5em] dark:text-ink-muted">
        {{ stat.label }}
      </span>
      <div class="flex items-baseline gap-2">
        <span class="text-[28px] font-bold text-[#141437] dark:text-ink-muted">{{ stat.value }}</span>
        @if(stat.difference !== undefined) {
        <div class="flex items-center" [ngClass]="stat.difference >= 0 ? 'text-green-500' : 'text-red-500'">
          <app-icon-v2 [name]="stat.difference >= 0 ? 'trendingUp' : 'trendingDown'" [size]="10"></app-icon-v2>
          <span class="text-[10px] font-bold ml-0.5">
            {{ stat.difference >= 0 ? '' : '' }}{{ stat.difference }}%
          </span>
        </div>
        }
      </div>
    </div>
    }
  </div>
</div>
  }
} @else if (mobileDetailedView() === 'activeBusinesses') {
  <div class="bg-white dark:bg-surface-1">
    <!-- Sticky Header -->
    <div class="sticky top-0 z-50 bg-white px-4 py-4 flex items-center justify-start border-b border-gray-100 shadow-sm dark:bg-surface-1">
      <button (click)="closeMobileDetail()" class="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center active:scale-95 transition-all">
        <app-icon-v2 name="ChevronLeft" [size]="24" customClass="text-[#38385B] dark:text-white"></app-icon-v2>
      </button>
      <h2 class="text-[18px] font-bold text-[#141437] ml-3 dark:text-white">Active Businesses Overview</h2>
    </div>

    <div class="p-4">
      <!-- Filter/Date Range -->
      <div class="flex items-center justify-between mb-6 dark:bg-surface-1 dark:border-b dark:border-line">
        <p class="text-[14px] font-medium text-[#38385B] dark:text-white">
          {{ startDate() | date:'MMM dd' }} — {{ endDate() | date:'MMM dd' }}
        </p>
        <button (click)="openFilterSheet()" class="text-[14px] font-semibold text-[#0C66E8] dark:text-[#0C66E8]">Change Filter</button>
      </div>

      <!-- Main Detail Card -->
      <div class="bg-white dark:bg-surface-1 border border-gray-100 rounded-[32px] p-4 shadow-[0px_12px_16px_-4px_rgba(16,24,40,0.08)] mb-6">
        <div class="flex items-center justify-between mb-2">
          <h3 class="text-[16px] font-medium text-[#38385B] dark:text-white">Active Businesses</h3>
          <!-- Chart Type Toggle -->
          <div class="flex bg-gray-100 dark:bg-surface-3 rounded-xl p-1">
            <button 
              (click)="setMobileChartType('bar')"
              [ngClass]="mobileChartType() === 'bar' ? 'bg-white dark:bg-surface-3 shadow-sm text-[#0C66E8] dark:text-purple-500' : 'text-gray-500  dark:text-purple-500'"
              class="w-10 h-8 flex items-center justify-center rounded-lg transition-all">
              <app-icon-v2 name="chartnoaxescolumnincreasing" [size]="18"></app-icon-v2>
            </button>
            <button 
              (click)="setMobileChartType('line')"
              [ngClass]="mobileChartType() === 'line' ? 'bg-white dark:bg-surface-1 shadow-sm text-[#0C66E8] dark:text-purple-500' : 'text-gray-500  dark:text-purple-500'"
              class="w-10 h-8 flex items-center justify-center rounded-lg transition-all">
              <app-icon-v2 name="TrendingUp" [size]="18"></app-icon-v2>
            </button>
          </div>
        </div>

        <div class="mb-4 flex flex-col max-w-max">
          <span class="text-[48px] font-bold text-[#141437] dark:text-white tracking-tight">
            {{ activeBusiness()?.statsData?.total || 0 }}
          </span>
          <div class="w-full mt-0 flex px-3 py-1 bg-[#F4E5FF] dark:bg-purple-500/10 rounded-lg">
            <span class="text-[12px] font-semibold text-[#AD46FF] dark:text-white">
              Average active businesses : {{ activeBusiness()?.statsData?.average_last_6 || activeBusiness()?.statsData?.average || 0 }}
            </span>
          </div>
        </div>

        <!-- Chart Area -->
        <div class="w-full h-[340px] mt-8">
          @if (mobileChartType() === 'bar') {
            <div class="w-full h-full overflow-x-auto overflow-y-hidden no-scrollbar pb-2">
              <div class="h-full" [style.min-width.px]="activeBusinessChartScrollWidth()">
                <app-multiple-bar [data1]="activeBusiness()?.chartData || []"
                [data2]="activeBusiness()?.previousChartData || []" [valueKey]="'value'" [addGradient]="true"
                  [barTextposition]="'top'" [barClusterPixel]="20"
                  [showDynamicxAxisLabel]="true" [darkBarOutlineFill]="'#AD46FF'" [lightBarOutlineFill]="'#F4E5FF'"
                  [barClusterHeight]="50" [unit]="unit()" [colors]="colors" [xAxisShowOnlyFirstLast]="true"
                  [showAllXticks]="false" [valueType]="'number'"
                  [margin]="{ top: 20, right: 10, bottom: 50, left: 40 }">
                </app-multiple-bar>
              </div>
            </div>
          } @else {
            <app-line-chart [data1]="activeBusiness()?.chartData || []" [data2]="activeBusiness()?.previousChartData || []"
              [valueKey]="'value'" [unit]="unit()" [showYAxis]="true" [showXAxis]="true" [showXAxisGrid]="true"
              [xAxisShowOnlyFirstLast]="true" [showAllXticks]="false" [showAllXLabels]="false"
              [showCircleStrokes]="true" [showYAxisGrid]="true" [showYAxisPath]="true" [curveType]="'curveMonotoneX'">
            </app-line-chart>
          }
        </div>
      </div>
    </div>
  </div>
} @else if (mobileDetailedView() === 'topBusinesses') {
  <div class="bg-white dark:bg-surface-1">
    <!-- Sticky Header -->
    <div class="sticky top-0 z-50 bg-white px-4 py-4 flex items-center justify-start border-b border-gray-100 shadow-sm dark:bg-surface-1">
      <button (click)="closeMobileDetail()" class="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center active:scale-95 transition-all">
        <app-icon-v2 name="ChevronLeft" [size]="24" customClass="text-[#38385B] dark:text-white"></app-icon-v2>
      </button>
      <h2 class="text-[18px] font-bold text-[#141437] dark:text-white ml-3">Top 10 Businesses</h2>
    </div>

    <div class="p-4">
      <!-- Podium Section -->
      <div class="bg-white dark:bg-surface-1 dark:border dark:border-surface-1 border border-gray-100 rounded-[32px] px-4 py-6 shadow-[0px_12px_16px_-4px_rgba(16,24,40,0.08)] mb-6">
        <div class="h-[240px] flex items-end justify-center relative">
          @for (item of podiumConfig(); track item.rank) {
            <div class="relative w-[33%] {{ item.barColor }} {{ item.z }} flex flex-col items-center justify-between {{ item.pb }} {{ item.pt }} px-2 rounded-t-xl"
                 [style.height]="item.barHeight">
              <!-- Rank Circle -->
              <div class="absolute {{ item.circleTop }} left-1/2 -translate-x-1/2 {{ item.circleSize }} bg-white rounded-full p-1 shadow-md">
                <div class="w-full h-full bg-gradient-to-br {{ item.gradient }} rounded-full flex items-center justify-center text-white dark:text-surface-1 font-bold {{ item.circleText }}">
                  {{ item.rank }}
                </div>
              </div>
              <!-- Business Name -->
              <span class="{{ item.textSize }} text-white dark:text-surface-1 font-bold text-center line-clamp-2 px-1 leading-tight">{{ item.business.label }}</span>
              <!-- Value -->
              <span class="{{ item.valueSize }} text-white dark:text-surface-1 font-bold drop-shadow-sm">{{ item.business.value }}</span>
            </div>
          }
        </div>
      </div>

      <!-- List Section (Ranks 4-10) -->
      <div class="flex flex-col gap-3 mb-4">
        @for (item of remainingTopBusinesses(); track item.rank) {
          <div class="bg-white dark:bg-surface-1 dark:border dark:border-line border border-gray-100 rounded-2xl p-4 flex items-center justify-between shadow-sm transition-all active:scale-[0.98]">
            <div class="flex items-center gap-4">
              <!-- Rank Index -->
              <div class="w-8 h-8 rounded-full bg-gray-100 flex dark:bg-surface-3 items-center justify-center">
                <span class="text-[14px] font-bold text-[#38385B]  dark:text-ink-soft">{{ item.rank }}</span>
              </div>
              <!-- Business Name -->
              <span class="text-[16px] font-medium text-[#141437] dark:text-ink-soft">{{ item.label }}</span>
            </div>
            <!-- Value -->
            <span class="text-[16px] font-bold text-[#38385B] dark:text-ink-soft">{{ item.value }}</span>
          </div>
        }
      </div>
    </div>
  </div>
} @else if (mobileDetailedView() === 'topCategories') {
  <div class="bg-white dark:bg-surface-1">
    <!-- Sticky Header -->
    <div class="sticky top-0 z-50 bg-white px-4 py-4 flex items-center justify-start border-b border-gray-100 shadow-sm dark:bg-surface-1">
      <button (click)="closeMobileDetail()" class="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center active:scale-95 transition-all">
        <app-icon-v2 name="ChevronLeft" [size]="24" customClass="text-[#38385B] dark:text-white"></app-icon-v2>
      </button>
      <h2 class="text-[18px] font-bold text-[#141437] dark:text-white ml-3">Top Categories by Contracts</h2>
    </div>

    <div class="p-4 flex flex-col gap-6">
      @for (item of fullCategoryList(); track item.label) {
        <div class="flex flex-col gap-2">
          <div class="flex items-center justify-between">
            <span class="text-[16px] font-medium text-[#38385B] dark:text-white">{{ item.label }}</span>
            <span class="text-[16px] font-bold text-[#141437] dark:text-white">{{ item.value }}</span>
          </div>
          <!-- Progress Bar -->
          <div class="w-full h-4 bg-gray-100 rounded-full overflow-hidden">
            <div class="h-full rounded-full bg-gradient-to-r {{ item.gradient }} transition-all duration-1000 ease-out relative"
                 [style.width.%]="item.percentage">
              <!-- Optional: Striped pattern like in image -->
              <div class="absolute inset-0 opacity-20 bg-[linear-gradient(45deg,rgba(255,255,255,.15)_25%,transparent_25%,transparent_50%,rgba(255,255,255,.15)_50%,rgba(255,255,255,.15)_75%,transparent_75%,transparent)] bg-[length:1rem_1rem]"></div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
} @else if (mobileDetailedView() === 'overallContracts') {
  <div class="bg-white dark:bg-surface-1">
    <!-- Sticky Header -->
    <div class="sticky top-0 z-50 bg-white dark:bg-surface-1 px-4 py-4 flex items-center justify-start border-b border-gray-100 shadow-sm">
      <button (click)="closeMobileDetail()" class="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center active:scale-95 transition-all">
        <app-icon-v2 name="ChevronLeft" [size]="24" customClass="text-[#38385B] dark:text-white"></app-icon-v2>
      </button>
      <h2 class="text-[18px] font-bold text-[#141437] dark:text-white ml-3">Overall Contract Count</h2>
    </div>

    <div class="p-4">
      <!-- Donut Chart Card -->
      <div class="bg-white dark:bg-surface-1 border border-gray-100 rounded-[32px] p-6 shadow-[0px_12px_16px_-4px_rgba(16,24,40,0.08)] mb-6">
        <div class="w-full relative">
          <app-pie-chart 
            [data]="overallContractsList()" 
            [isDonut]="true" 
            [donutRadiusRatio]="0.6"
            [width]="300"
            [height]="300"
            [showPolylines]="false"
            [polylineValueFormat]="'percentage'"
            [centerValue]="overallContractsTotal().toLocaleString()"
            [centerLabel]="'Total Count'"
            [showLegend]="false"
            [keepLabelsOnHover]="true">
          </app-pie-chart>
        </div>
      </div>

      <!-- Legend List -->
      <div class="flex flex-col border border-gray-100 rounded-2xl overflow-hidden shadow-sm">
        @for (item of overallContractsList(); track item.label) {
          <div class="bg-white dark:bg-surface-1 p-4 flex items-center justify-between border-b last:border-b-0 border-gray-50 ">
            <div class="flex items-center gap-3">
              <!-- Color Dot -->
              <div class="w-3 h-3 rounded-full" [style.backgroundColor]="item.color"></div>
              <!-- Name -->
              <span class="text-[14px] font-medium text-[#38385B] dark:text-white">{{ item.label }}</span>
            </div>
            <!-- Value -->
            <span class="text-[14px] font-bold text-[#141437] dark:text-white">{{ item.value.toLocaleString() }}</span>
          </div>
        }
      </div>
    </div>
  </div>
} @else if (mobileDetailedView() === 'enrolledBusinesses') {
  <div class="bg-white dark:bg-surface-1">
    <!-- Sticky Header -->
    <div class="sticky top-0 z-50 bg-white dark:bg-surface-1 border-b border-gray-100 shadow-sm">
      <div class="px-4 py-4 flex items-center justify-start">
        <button (click)="closeMobileDetail()" class="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center active:scale-95 transition-all">
          <app-icon-v2 name="ChevronLeft" [size]="24" customClass="text-[#38385B] dark:text-white"></app-icon-v2>
        </button>
        <h2 class="text-[18px] font-bold text-[#141437] dark:text-white ml-3">Enrolled Businesses</h2>
      </div>
      <!-- Search Bar -->
      <div class="px-4 pb-4">
        <div class="relative">
          <span class="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 dark:text-ink-muted ">
            <app-icon-v2 name="search" [size]="20"></app-icon-v2>
          </span>
          <input type="text" 
                 [ngModel]="enrolledSearchQuery()"
                 (ngModelChange)="updateEnrolledSearch($event)"
                 placeholder="Search Here" 
                 class="w-full h-12 bg-gray-50 border border-gray-100 dark:bg-surface-1 dark:border dark:border-line dark:text-ink-muted rounded-2xl pl-12 pr-4 text-[14px] font-medium text-[#141437] placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20">
        </div>
      </div>
    </div>

    <!-- List Content -->
    <div class="p-4 flex flex-col gap-1">
      @for (item of fullEnrolledBusinessList(); track item.name) {
        <div class="flex items-center justify-between p-3 rounded-2xl hover:bg-gray-50 transition-all active:scale-[0.98]">
          <div class="flex items-center gap-4">
            <div class="w-10 h-10 rounded-full overflow-hidden border border-gray-100 shadow-sm">
              <img [src]="item.icon" [alt]="item.name" class="w-full h-full object-cover">
            </div>
            <span class="text-[16px] font-medium text-[#38385B] dark:text-white">{{ item.name }}</span>
          </div>
          <span class="text-[16px] font-bold text-[#141437] dark:text-white">{{ item.value.toLocaleString() }}</span>
        </div>
      } @empty {
        <div class="flex flex-col items-center justify-center py-20 text-gray-500">
          <app-icon-v2 name="search" [size]="48" class="text-gray-300 mb-4"></app-icon-v2>
          <p class="font-medium">No results found for "{{ enrolledSearchQuery() }}"</p>
        </div>
      }
    </div>
  </div>
} @else if (mobileDetailedView() === 'contractsCreated') {
  <div class="bg-white dark:bg-surface-1">
    <!-- Sticky Header -->
    <div class="sticky top-0 z-50 bg-white dark:bg-surface-1 border-b border-gray-100 shadow-sm">
      <div class="px-4 py-4 flex items-center justify-start">
        <button (click)="closeMobileDetail()" class="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center active:scale-95 transition-all">
          <app-icon-v2 name="ChevronLeft" [size]="24" customClass="text-[#38385B] dark:text-white"></app-icon-v2>
        </button>
        <h2 class="text-[18px] font-bold text-[#141437] dark:text-white ml-3">Contracts Created</h2>
      </div>
      <!-- Search Bar -->
      <div class="px-4 pb-4">
        <div class="relative">
          <span class="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
            <app-icon-v2 name="search" [size]="20"></app-icon-v2>
          </span>
          <input type="text" 
                 [ngModel]="contractsSearchQuery()"
                 (ngModelChange)="updateContractsSearch($event)"
                 placeholder="Search Here" 
                 class="w-full h-12 bg-gray-50 border border-gray-100 dark:bg-surface-1 dark:border dark:border-line dark:text-ink-muted rounded-2xl pl-12 pr-4 text-[14px] font-medium text-[#141437] placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20">
        </div>
      </div>
    </div>

    <!-- List Content -->
    <div class="p-4 flex flex-col gap-1">
      @for (item of fullRegionalContractsList(); track item.name) {
        <div class="flex items-center justify-between p-3 rounded-2xl hover:bg-gray-50 transition-all active:scale-[0.98]">
          <div class="flex items-center gap-4">
            <div class="w-10 h-10 rounded-full overflow-hidden border border-gray-100 shadow-sm">
              <img [src]="item.icon" [alt]="item.name" class="w-full h-full object-cover">
            </div>
            <span class="text-[16px] font-medium text-[#38385B] dark:text-white">{{ item.name }}</span>
          </div>
          <span class="text-[16px] font-bold text-[#141437] dark:text-white ">{{ item.value.toLocaleString() }}</span>
        </div>
      } @empty {
        <div class="flex flex-col items-center justify-center py-20 text-gray-500">
          <app-icon-v2 name="search" [size]="48" class="text-gray-300 mb-4"></app-icon-v2>
          <p class="font-medium">No results found for "{{ contractsSearchQuery() }}"</p>
        </div>
      }
    </div>
  </div>
}

<!-- Ask Prism AI FAB -->
@if (!mobileDetailedView()) {
  <button (click)="openAiPanel()"
    class="fixed bottom-45 right-6 w-14 h-14 p-[2px] bg-gradient-to-tr from-[#AD46FF] via-[#35D86B] to-[#2FEFF5] rounded-full shadow-[0px_8px_16px_rgba(173,70,255,0.3)] z-[6500] active:scale-95 transition-all duration-500 ease-in-out group cursor-pointer border-none"
    [ngClass]="{
      'translate-y-[82px]': !showNav() && showFloatingBar(),
      'translate-y-[500px]': !showFloatingBar()
    }">
    <div class="w-full h-full bg-white rounded-full flex items-center justify-center">
      <app-icon-v2 name="sparkles" [size]="24" class="text-[#AD46FF] relative z-10"></app-icon-v2>
    </div>
  </button>
}
